module.exports = __webpack_public_path__ + "static/media/Home.4b181846.png";